import { BaseRestRepository } from './baseRestRepository';
import type {
  CreateRecurringLeaseCreditDto,
  RecurringLeaseCreditDto,
  RecurringLeaseCreditsDto,
  UpdateRecurringLeaseCreditDto,
} from '~/swagger/portal/Api';

const LEASES_URL = '/api/leases';

export class LeaseRecurringCreditRepository extends BaseRestRepository {
  public async getRecurringCredits(leaseId: string): Promise<RecurringLeaseCreditsDto> {
    const url = `${LEASES_URL}/${leaseId}/charges/recurring-credits`;
    const response = await this.fetchWithAuth(url, {
      method: 'GET',
    });
    return this.getJsonResponse(response);
  }

  public async addRecurringCredit(leaseId: string, payload: CreateRecurringLeaseCreditDto): Promise<RecurringLeaseCreditDto> {
    const url = `${LEASES_URL}/${leaseId}/charges/recurring-credits`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return this.getJsonResponse(response);
  }

  public async deleteRecurringCredit(leaseId: string, recurringCreditId: string, deleteAllCredits: boolean): Promise<void> {
    const url = `${LEASES_URL}/${leaseId}/charges/recurring-credits/${recurringCreditId}`;
    const response = await this.fetchWithAuth(url, {
      method: 'DELETE',
      body: JSON.stringify({
        deleteAllCredits,
      }),
    });
    if (!response.ok) {
      console.error(await response.json());
    }
  }
  public async updateLeaseRecurringCredit(
    leaseId: string,
    recurringCreditId: string,
    payload: UpdateRecurringLeaseCreditDto
  ): Promise<void> {
    const url = `${LEASES_URL}/${leaseId}/charges/recurring-credits/${recurringCreditId}`;
    await this.fetchWithAuth(url, {
      method: 'PUT',
      body: JSON.stringify(payload),
    });
  }
}
